"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormInput = void 0;
const React = require("react");
const _ = require("lodash");
const InputControls_1 = require("../../../../atoms/InputControls");
const InputDecoration_1 = require("../../../../atoms/InputDecoration");
const TextInput_1 = require("../../../../inputs/TextInput");
const FormGroup_1 = require("../FormGroup");
const FormFieldLayout_1 = require("../FormFieldLayout");
const inputs_1 = require("./helpers/inputs");
const FieldInputs_1 = require("../FieldInputs");
const formContext_1 = require("../../examples/helpers/formContext");
const Disable_1 = require("../../../../atoms/Disable");
const isNonValue = (val) => ["", null].indexOf(val) > -1;
/**
 * Strip off trailing non-values to act as if they're not there (avoid `false`
 * as this could be chosen value) avoids them being added to the styleForm object
 */
const stripTrailingBlanks = (ary) => isNonValue(_.last(ary)) ? stripTrailingBlanks(ary.slice(0, -1)) : ary;
class FormInput extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    renderGroup() {
        const { field } = this.props;
        const { label, layout, _instances: fieldInstances, allowMultiple, newInstanceLabel } = field;
        return (React.createElement(formContext_1.FormContext.Consumer, null, ({ newGroupInstance }) => (React.createElement(FormGroup_1.default, { onNewInstance: allowMultiple && (() => newGroupInstance(field)), newInstanceLabel: newInstanceLabel, label: label }, fieldInstances.map((instance, i) => (React.createElement(FieldInputs_1.default, { key: i, fields: instance.fields, layout: FormFieldLayout_1.formFieldLayoutTypes[layout] })))))));
    }
    renderInput() {
        const { field } = this.props;
        // pull out props that shouldn't be passed to the input
        const { value, errors, disabled } = field, inputProps = __rest(field, ["value", "errors", "disabled"]);
        // pull out props that are also passed/used by the input
        const { allowMultiple } = field;
        const { component: InputComponent, supportsMultiple = false, clearable = true, indentClear = false, _componentType } = (0, inputs_1.getInputComponentForField)(field);
        if (allowMultiple && !_.isArray(value)) {
            throw new Error("Mismatch in data");
        }
        // pass value (be it an array) straight through to a single input
        if (supportsMultiple || !allowMultiple) {
            return (React.createElement(formContext_1.FormContext.Consumer, null, ({ setFieldValue }) => {
                const onClear = () => {
                    // clearFieldValue(field);
                    setFieldValue(allowMultiple ? [] : null, field);
                };
                const hasValue = allowMultiple
                    ? value.length > 0
                    : !isNonValue(value);
                // merge all errors together as we do not have separate inputs to render them against
                const errorAry = allowMultiple
                    ? _.flatten(errors).filter(x => x)
                    : errors;
                return (React.createElement("div", { "data-test-component-type": _componentType, "data-test-map": `${field._path}`, "data-required": field.required, "data-hint": `${field.type}` },
                    React.createElement(InputControls_1.InputControls, { onClearValue: clearable && !disabled && hasValue && onClear, errors: errorAry, indentClear: indentClear },
                        React.createElement("div", { "data-test": "input-component" },
                            React.createElement(InputComponent, Object.assign({ value: value, onInputChange: (val) => {
                                    setFieldValue(val, field);
                                } }, inputProps))))));
            }));
        }
        let valueAry = _.clone(value);
        let errorAry = _.clone(errors);
        // add a value to the end of the array if empty or full with values
        // ensures a field is always showing or causes a new instance to be rendered when previous is filled
        if (value.length === 0 || _.last(value) !== null) {
            valueAry = valueAry.concat([null]);
        }
        // treat field level errors as errors on the first value, i.e. merge first and second
        if (errorAry.length > 1) {
            const fieldErrors = errorAry.shift();
            // check errors exist
            if (_.isArray(fieldErrors)) {
                // check the first field has its own errors
                if (_.isArray(errorAry[0])) {
                    errorAry[0] = fieldErrors.concat(errorAry[0]);
                }
                else {
                    errorAry[0] = fieldErrors;
                }
            }
        }
        // limit number of instances based on specified limits
        const { maxInstances = false } = field;
        if (maxInstances) {
            valueAry = valueAry.slice(0, maxInstances);
            errorAry = errorAry.slice(0, maxInstances);
        }
        return (React.createElement(formContext_1.FormContext.Consumer, null, ({ setFieldValue }) => valueAry.map((v, i) => {
            const onClear = () => {
                const newValues = [].concat(valueAry);
                newValues[i] = null;
                setFieldValue(stripTrailingBlanks(newValues), field);
            };
            const hasValue = !isNonValue(v);
            // note - may not have error information for unvalidated instances, hence the error array check
            return (React.createElement("div", { "data-test-component-type": _componentType, "data-test-map": `${field._path}.${i}`, "data-required": field.required, key: `${field._path}.${i}` },
                React.createElement(InputControls_1.InputControls, { onClearValue: clearable && !disabled && hasValue && onClear, errors: i < errorAry.length ? errorAry[i] : false },
                    React.createElement("div", { "data-test": "input-component" },
                        React.createElement(InputComponent, Object.assign({ value: v, onInputChange: (val) => {
                                const newValues = _.clone(valueAry);
                                newValues[i] = val;
                                setFieldValue(stripTrailingBlanks(newValues), field);
                            } }, inputProps))))));
        })));
    }
    render() {
        const { field } = this.props;
        // value is retained in the styleForm - no need to render an input
        if ((0, inputs_1.isHiddenField)(field)) {
            return null;
        }
        // score fields aren't to be displayed to the user.
        if ((0, inputs_1.isScoreField)(field)) {
            return null;
        }
        const { label, description, descriptionImageUrl, required, _visible: visible, _illegal: illegal, value, allowMultiple, disabled } = field;
        if (!visible) {
            return null;
        }
        // does the field hold an illegal value
        if (illegal) {
            return (React.createElement(Disable_1.Disable, { disabled: true },
                React.createElement(InputDecoration_1.InputDecoration, { label: label, description: description, descriptionImageUrl: descriptionImageUrl },
                    React.createElement(InputControls_1.InputControls, null,
                        React.createElement(TextInput_1.TextInput, { value: allowMultiple ? value.join(",") : value, onInputChange: () => { } })),
                    React.createElement("p", null, "NOTE: the current value is unrecognised and cannot be edited."))));
        }
        return (React.createElement(Disable_1.Disable, { disabled: disabled }, (0, inputs_1.isGroupField)(field) ? (this.renderGroup()) : (React.createElement(InputDecoration_1.InputDecoration, { label: label, description: description, isRequired: required, descriptionImageUrl: descriptionImageUrl }, this.renderInput()))));
    }
}
exports.FormInput = FormInput;
FormInput.defaultProps = {
    field: {
        type: "text",
        _visible: true
    }
};
// TODO - legacy support
exports.default = FormInput;
//# sourceMappingURL=index.js.map